import { useState, useRef } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputTextArea from "../../helpers/InputTextArea";
import InputCombo from "../../helpers/InputCombo";
import InputDecimal from "../../helpers/InputDecimal";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputDate from "../../helpers/InputDate";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputPESEL from "../../helpers/InputPESEL";
import InputText from "../../helpers/InputText";
import InputPhone from "../../helpers/InputPhone";
import InputEmail from "../../helpers/InputEmail";

import back from "../../back.png";



function NoticeOnlineEdit(props)
{

      

    const [errTab, setErrTab] = useState([]);  //z info od serwera..

    const [emps, setEmps] = useState(null); //pracownicy..



    const [row, setRowX] = useState({
         id: props.row.id,
         numer_zgloszenia: props.row.numer_zgloszenia,
         imie: props.row.imie,
         nazwisko: props.row.nazwisko,
         data_urodzenia: props.row.data_urodzenia,
         miasto: props.row.miasto,
         ulica: props.row.ulica,
         nr_domu: props.row.nr_domu,
         nr_mieszkania: props.row.nr_mieszkania,
         kod_pocztowy: props.row.kod_pocztowy,
         proponowana_data_przyjecia: props.row.proponowana_data_przyjecia,
         telefon_kontaktowy: props.row.telefon_kontaktowy,
         e_mail: props.row.e_mail,
         status: props.row.status,
         created_at: props.row.created_at,
         kwota_wpisowa: props.row.kwota_wpisowa,
         kwota_zaplacona: props.row.kwota_zaplacona,

         informacje_dodatkowe: props.row.informacje_dodatkowe,

         powiadomienie: '_x_',

         uwagi_rekruta: props.row.uwagi_rekruta,
         p_subkonta_id: props.row.p_subkonta_id,

         oddzial_ulica: props.row.oddzial_ulica,

         r1_imie: props.row.r1_imie,
         r1_nazwisko: props.row.r1_nazwisko,
         r1_ulica: props.row.r1_ulica,
         r1_kod_pocztowy: props.row.r1_kod_pocztowy,
         r1_miejscowosc: props.row.r1_miejscowosc,
         r1_email: props.row.r1_email,
         r1_telefon: props.row.r1_telefon,
         r1_pesel: props.row.r1_pesel,

         r2_imie: props.row.r2_imie,
         r2_nazwisko: props.row.r2_nazwisko,
         r2_ulica: props.row.r2_ulica,
         r2_kod_pocztowy: props.row.r2_kod_pocztowy,
         r2_miejscowosc: props.row.r2_miejscowosc,
         r2_email: props.row.r2_email,
         r2_telefon: props.row.r2_telefon,
         r2_pesel: props.row.r2_pesel,

         pesel: props.row.pesel, 

       
     });
     var tmpRow = row;




     const valChecker = (fields) => {

        var allValid = true;

              
        console.log(JSON.stringify(fields) );

        Object.entries(fields).forEach(function(entry) {

            var xKey    = entry[0];
            var xValue  = entry[1];                    

            var xValidName = xKey + "_valid";

            if(fields[xValidName] == false)
            {
                allValid = false;
                console.log("Error field: " + xKey);
            }
            
          });
        
          return allValid;

    }


    const valChangeListener = (filedName, val, correct, msg) => {         
        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
      
      
        tmpRow[filedName] = val;
        tmpRow[filedName+"_valid"] = correct;         
        setRowX(  JSON.parse(JSON.stringify(tmpRow)) );    
    
        //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );    


     
    }   


    const goNextNew = () => {
        console.log("goNext");
        saveData();
    }

    const saveData = () => {




        if(!valChecker(row))
        {
            props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
            return;
        }
    

        props.mainView.setProgress(-2);

        var req = row;

        fetch( Config.url + '/rest_v1_kids,notice_online_update', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                       // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                       setErrTab(res.result);
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {

                        if(props.onSuccess != undefined) props.onSuccess();

                        props.mainView.showDialog( "Sukces",  "Zmiany zostały zapisane", "ok" , null);                                                                  
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }
 



    var itemsStatus = [
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: 'NOWE',
            title: 'Nowe'
        }, 
        {
            v: 'W TRAKCIE WERYFIKACJI',
            title: 'W trakcie weryfikacji'
        },       
        {
            v: 'ODRZUCONE',
            title: 'Odrzucone'
        },    
        {
            v: 'WYMAGANE WPISOWE + WYŚWIETL FORMULARZ PŁATNOŚCI BlueMedia',
            title: 'Wymagane wpisowe + wyświetl formularz płatności'
        }, 
        {
            v: 'PRZYJĘTE - OPŁACONE PRZEZ RODZICA - Blue Media',
            title: 'Opłacone przez rodzica (OnLine)'
        },  
        {
            v: 'PRZYJĘTE - OPŁACONE PRZEZ RODZICA - Inny sposób',
            title: 'Opłacone przez rodzica (Inny sposób)'
        },  
        {
            v: 'PRZYJĘTE - OPŁACONE - UTWORZONE W SYSTEMIE',
            title: 'Dziecko przyjęte i utworzone w systemie'
        },          

    ];


    var itemsTakNie = [
        {
            v: '_x_',
            title: ' - - - '
        },
        {
            v: 'sms',
            title: 'Tak - SMS'
        }, 
        {
            v: 'email',
            title: 'Tak - E-mail'
        },       
        {
            v: 'all',
            title: 'Tak - E-mail i SMS'
        },          

    ];



    return     <div className="view_content">

                    <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>

                   <h1><PlTitle userData={props.userData} /> / {row.numer_zgloszenia}</h1>

                   {
                    row.informacje_dodatkowe.length > 2 &&
                    <div style={{padding:'10px'}}>
                        {row.informacje_dodatkowe}
                    </div>
                   }
      
                   <form className="eForm bg_center">


                            <div className="h_separate">Status wniosku</div>

                            <div className="form_tab">
                          
                                         

                                        <div className="form_control">
                                                <div className="fieldName">Status*</div>
                                                <InputCombo items={itemsStatus}   userData={props.userData} value={row.status} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="status" placeholder={"Status"} className='   ' req='1' firstUp="1" />
                                        </div>

                                        <div className="form_control">
                                                <div className="fieldName">Wysłać powiadomienie o zmianie statusu?</div>
                                               <InputCombo items={itemsTakNie}   userData={props.userData} value={row.powiadomienie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="powiadomienie" placeholder={""} className=' w200 ' req='1' firstUp="1" />
                                            </div>


                                        <div className="form_split"></div>   
                                        

                                        <div className="form_control">
                                                <div className="fieldName"> Kwota wpisowego (min. 1.00 zł jeśli wymagane wpisowe)</div>
                                                <InputDecimal   userData={props.userData} value={row.kwota_wpisowa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kwota_wpisowa" placeholder={"Kwota"} className='  ' req='1' firstUp="1" />
                                        </div>

                                        {
                                            row.kwota_wpisowa > 0 &&
                                            <div className="form_control">
                                                <div className="fieldName"> SubKonto (dla płatności OnLine jeśli wymagane wpisowe)</div>
                                                <InputComboSubkonto   userData={props.userData} mainView={props.mainView}  value={row.p_subkonta_id} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="p_subkonta_id" placeholder={""} className='  ' req='1' firstUp="1" />
                                            </div>

                                        }
                                        


                                        <div className="form_split"></div>

                                        <div className="form_control p95">      
                                                  <div className="fieldName">Informacje dla osoby składającej wniosek</div>
                                                  <InputTextArea   userData={props.userData} value={row.uwagi_rekruta} err={errTab}  valChange={valChangeListener}   name="uwagi_rekruta" placeholder={"Informacje:"} className='p100 h100' req='1'   />
                                         </div>

                            </div>


                            <div className="h_separate">Informacje o dziecku i opiekunach</div>



                            <div className="form_tab_title">Dane dziecka:</div>
                            <div className="form_tab">                                   
                                     
                                            <div className="form_control">
                                                        <div className="fieldName">Proponowana data przyjęcia </div>
                                                        <InputDate   userData={props.userData} value={row.proponowana_data_przyjecia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="proponowana_data_przyjecia" placeholder={""} className=' ' req='1'   />
                                            </div>


                                            <div className="form_control">
                                                <div className="fieldName">Oddział / ulica</div>
                                                <InputText  userData={props.userData} value={row.oddzial_ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="oddzial_ulica" placeholder={"Oddział / ulica:"} className=' w200 ' req='0' />
                                            </div>


                                            <div className="form_split"></div>


                                            <div className="form_control">
                                                <div className="fieldName">Imię</div>
                                                <InputTextAlpha   userData={props.userData} value={row.imie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="imie" placeholder={"Imię:"} className=' w100 ' req='0' firstUp="1" />
                                            </div> 

                                            <div className="form_control">
                                                <div className="fieldName">Nazwisko</div>
                                                <InputTextAlpha   userData={props.userData} value={row.nazwisko} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nazwisko" placeholder={"Nazwisko:"} className=' w100 ' req='0' firstUp="1" />
                                            </div>


                                            <div className="form_control">
                                                <div className="fieldName">PESEL</div>
                                                <InputText  userData={props.userData} value={row.pesel} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="pesel" placeholder={"PESEL:"} className=' w100 ' req='0' />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Data urodzenia</div>
                                                <InputDate  userData={props.userData} value={row.data_urodzenia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="data_urodzenia" placeholder={"Data urodzenia:"} className='   ' req='0' />
                                            </div>


                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                        <div className="fieldName">Ulica</div>
                                                        <InputText  userData={props.userData} value={row.ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="ulica" placeholder={"Ulica:"} className=' w200 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Nr domu</div>
                                                        <InputText  userData={props.userData} value={row.nr_domu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nr_domu" placeholder={"Nr domu:"} className=' w50 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Nr mieszkania</div>
                                                        <InputText  userData={props.userData} value={row.nr_mieszkania} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="nr_mieszkania" placeholder={"Nr mieszkania:"} className=' w50 ' req='0'  />
                                            </div>

                                           

                                            <div className="form_control">
                                                        <div className="fieldName">Kod pocztowy</div>
                                                        <InputText  userData={props.userData} value={row.kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kod_pocztowy" placeholder={"Nr mieszkania:"} className=' w100 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Miasto</div>
                                                        <InputText  userData={props.userData} value={row.miasto} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="miasto" placeholder={"Nr mieszkania:"} className=' w100 ' req='0'  />
                                            </div>



                            </div>


                            <div className="form_tab_title">Dane opiekuna nr 1:</div>
                            <div className="form_tab">
                                        
                                            <div className="form_control">
                                                <div className="fieldName">Imię</div>
                                                <InputTextAlpha   userData={props.userData} value={row.r1_imie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r1_imie" placeholder={"Imię:"} className=' w100 ' req='0' firstUp="1" />
                                            </div> 

                                            <div className="form_control">
                                                <div className="fieldName">Nazwisko</div>
                                                <InputTextAlpha   userData={props.userData} value={row.r1_nazwisko} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r1_nazwisko" placeholder={"Nazwisko:"} className=' w100 ' req='0' firstUp="1" />
                                            </div>


                                            <div className="form_control">
                                                        <div className="fieldName">PESEL</div>
                                                        <InputText  userData={props.userData} value={row.r1_pesel} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r1_pesel" placeholder={"PESEL:"} className=' w100 ' req='0'  />
                                            </div>


                                            <div className="form_split"></div>


                                          <div className="form_control">
                                                        <div className="fieldName">Ulica / nr domu / mieszkania</div>
                                                        <InputText  userData={props.userData} value={row.r1_ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r1_ulica" placeholder={"Ulica:"} className=' w100 ' req='0'  />
                                            </div>

                                           

                                            <div className="form_control">
                                                        <div className="fieldName">Kod pocztowy</div>
                                                        <InputText  userData={props.userData} value={row.r1_kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r1_kod_pocztowy" placeholder={"Kod pocztowy:"} className=' w100 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Miasto</div>
                                                        <InputText  userData={props.userData} value={row.r1_miejscowosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r1_miejscowosc" placeholder={"Miejscowość:"} className=' w150 ' req='0'  />
                                            </div>


                                            <div className="form_control">
                                                <div className="fieldName">E-mail</div>
                                                <InputEmail   userData={props.userData} value={row.r1_email} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r1_email" placeholder={"E-mail:"} className='  ' req='0' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Telefon</div>
                                                <InputPhone   userData={props.userData} value={row.r1_telefon} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r1_telefon" placeholder={"Telefon:"} className='  ' req='0' firstUp="0" />
                                            </div>

                            </div>



                            <div className="form_tab_title">Dane opiekuna nr 2:</div>
                            <div className="form_tab">
                                       
                                            <div className="form_control">
                                                <div className="fieldName">Imię</div>
                                                <InputTextAlpha   userData={props.userData} value={row.r2_imie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r2_imie" placeholder={"Imię:"} className=' w100 ' req='0' firstUp="1" />
                                            </div> 

                                            <div className="form_control">
                                                <div className="fieldName">Nazwisko</div>
                                                <InputTextAlpha   userData={props.userData} value={row.r2_nazwisko} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r2_nazwisko" placeholder={"Nazwisko:"} className=' w100 ' req='0' firstUp="1" />
                                            </div>


                                            <div className="form_control">
                                                        <div className="fieldName">PESEL</div>
                                                        <InputText  userData={props.userData} value={row.r2_pesel} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r2_pesel" placeholder={"PESEL:"} className=' w100 ' req='0'  />
                                            </div>

                                                <div className="form_split"></div>

                                            
                                          <div className="form_control">
                                                        <div className="fieldName">Ulica / nr domu / mieszkania</div>
                                                        <InputText  userData={props.userData} value={row.r2_ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r2_ulica" placeholder={"Ulica:"} className=' w100 ' req='0'  />
                                            </div>

                                           

                                            <div className="form_control">
                                                        <div className="fieldName">Kod pocztowy</div>
                                                        <InputText  userData={props.userData} value={row.r2_kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r2_kod_pocztowy" placeholder={"Kod pocztowy:"} className=' w100 ' req='0'  />
                                            </div>

                                            <div className="form_control">
                                                        <div className="fieldName">Miasto</div>
                                                        <InputText  userData={props.userData} value={row.r2_miejscowosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r2_miejscowosc" placeholder={"Miejscowość:"} className=' w150 ' req='0'  />
                                            </div>



                                            <div className="form_control">
                                                <div className="fieldName">E-mail</div>
                                                <InputEmail   userData={props.userData} value={row.r2_email} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r2_email" placeholder={"E-mail:"} className='  ' req='0' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Telefon</div>
                                                <InputPhone   userData={props.userData} value={row.r2_telefon} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="r2_telefon" placeholder={"Telefon:"} className='  ' req='0' firstUp="0" />
                                            </div>
                            </div>

                            
                            <div className="form_split"></div>

                            <div className="form_btn">
                                    <div className="btn" onClick={saveData}>zapisz</div>
                                    &nbsp;&nbsp;
                                    <div className="btn" onClick={props.onBack}    > anuluj</div>
                            </div>



                    </form>

    </div>
}



export default NoticeOnlineEdit;